//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';

import UserDevices from '~/views/UserTransactions/UserDevices/UserDevicesTable.vue';
import UserOffers from '~/views/UserTransactions/UserOffers/Table.vue';
import UserDeals from '~/views/UserTransactions/UserDeals/Table.vue';


export default {
  components: {
    UserDeals,
    UserOffers,
    UserDevices,
  },

  computed: {
    ...mapState('user', ['user']),
    routerId() {
      return this.$route.params.id;
    },
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadUserDevices({ userId: this.user?.id }),
      this.loadTradersOffers({ userId: this.user?.id }),
      this.loadDeals({ userId: this.user?.id }),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),

    ...mapActions('tradersDeals', {
      loadDeals: 'loadData',
    }),
    ...mapActions('tradersOffers', {
      loadTradersOffers: 'loadData',
    }),
    ...mapActions('userDevices', {
      loadUserDevices: 'loadData',
    }),
  },
};
